import React from "react";

const ScoreCardForReading = (props) => {
  const numericScore = Number(props.score || 0);
  const numericMax = Number(props.maxScore || 1);
  const isPerfect = numericScore >= numericMax;
  const colorClass = isPerfect
    ? "border-green-200 bg-green-50 text-green-700"
    : "border-red-200 bg-red-50 text-red-700";

  return (
    <div
      className={`flex h-48 w-48 flex-col items-center justify-center rounded-full border-8 ${colorClass}`}
    >
      <span className="text-4xl font-extrabold">
        {props.score ?? "N/A"}/{props.maxScore ?? 1}
      </span>
      <span className="mt-2 text-xs font-bold uppercase tracking-wide">
        Score
      </span>
    </div>
  );
};

export default ScoreCardForReading;
